import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PscHttpService {

  constructor(private http: HttpClient) { }


  get(urlRoute: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/${urlRoute}`);
  }

  post(urlRoute:string, body: any, options?: any): Observable<any> {
    return this.http.post( `${environment.apiUrl}/${urlRoute}`, body, options);
  }

  put(urlRoute: string, body: any): Observable<any> {
    return this.http.put(`${environment.apiUrl}/${urlRoute}`, body);
  }

  delete(urlRoute: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/${urlRoute}`);
  }


  postReturnPdf(urlRoute: string, body: any, options?: any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.post(`${environment.apiUrl}/${urlRoute}`, body,{ headers: headers, responseType: 'blob', ...options});
  }

  getReturnPdf(urlRoute: string, options?: any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(`${ environment.apiUrl }/${ urlRoute }`, {
      headers: headers,
      responseType: 'blob', ...options,
    });
  }
}
